import { z } from "zod";
import { VALID_CHARACTER_IDS } from "@/constants/character";
import { VALID_VOICE_IDS } from "@/constants/audioVoice";

export const characterFormDataSchema = z.object({
  characterId: z.string().refine((id) => VALID_CHARACTER_IDS.includes(id), {
    message: "Invalid character ID",
  }),
});

export const voiceFormDataSchema = z.object({
  voiceId: z.string().refine((id) => VALID_VOICE_IDS.includes(id), {
    message: "Invalid voice ID",
  }),
  speed: z.string(),
});

export const multilingualOptionSchema = z.object({
  value: z.string(),
  label: z.string(),
  sublabel1: z.string().optional(),
  sublabel2: z.string().optional(),
  icon: z.string().optional(),
  multilingual: z.boolean(),
});

export const formDataSchema = z.object({
  language: multilingualOptionSchema,
  character: characterFormDataSchema,
  voice: voiceFormDataSchema,
});

export type FormDataSchema = z.infer<typeof formDataSchema>;
